import { TListingProduct } from "@/app/api/listing/[slug]/products/listing-products.dto";
import { showProductDetailsModal } from "@/components/common/product-listing-card";
import { useCommunityContext } from "@/providers/community-provider";
import { useCountryContext } from "@/providers/country-provider";
import { useModal } from "@/providers/modal-provider";
import { ImageIcon, MapPinIcon } from "lucide-react";
import Image from "next/image";
import { usePathname } from "next/navigation";

const GridViewProductCard = (props: TListingProduct) => {
	const { name, logo, description, slug, isClaimed, hqLocation, isBasedOnRegion } = props;
	const { openModal } = useModal();
	const pathname = usePathname();
	const { name: countryName, portals } = useCountryContext();
	const { communityInfo } = useCommunityContext();
	const communitySlug = communityInfo?.slug;
	const isCountryPortalPage =
		pathname === portals.current.href || pathname === `/communities/${communitySlug}/products`;

	return (
		<div
			onClick={() => showProductDetailsModal(name, slug, openModal)}
			className="relative flex w-fit cursor-pointer flex-col items-center justify-center rounded-lg bg-white p-4 text-center shadow-sm sm:w-64 sm:p-0 md:h-72"
		>
			{!isClaimed || isBasedOnRegion ? (
				<div className="absolute -top-3 left-1/2 w-max -translate-x-1/2 rounded-md bg-gray-100 px-2 py-1 text-xs text-gray-500">
					{!isClaimed && isBasedOnRegion
						? "Unclaimed | Based on operating region"
						: !isClaimed
						? "Unclaimed"
						: "Based on operating region"}
				</div>
			) : null}

			<div className="flex aspect-square h-24 w-24 items-center justify-center overflow-hidden rounded-xl border">
				{logo ? (
					<Image
						src={logo}
						alt={name}
						width={80}
						height={80}
						className="h-full w-full object-contain"
					/>
				) : (
					<ImageIcon className="h-5 w-5 text-gray-400" />
				)}
			</div>

			<h4 title={name} className="mt-4 line-clamp-2 font-semibold md:text-lg">
				{name}
			</h4>
			<p title={description} className="mt-1 line-clamp-2 px-2 text-sm text-gray-500">
				{description}
			</p>

			{hqLocation ||
				(countryName && (
					<div className="mt-4 hidden w-fit items-center gap-1 rounded-lg bg-gray-100 p-2 text-sm leading-4 text-gray-400 md:flex">
						<span>
							<MapPinIcon className="h-3 w-3 text-blue-600" />
						</span>
						<span>{isCountryPortalPage ? countryName : hqLocation}</span>
					</div>
				))}
		</div>
	);
};

export default GridViewProductCard;
